<lib-atividade-cadastro-view [atividadeNo]="atividadeNo" [processoNo]="processoNo" [enTheme]="enTheme"
  [isReadOnly]="readOnly" [ocorrenciaNo]="ocorrenciaNo" [saveInList]="saveInList"
  [defaultFormControls]="defaultFormControls" (afterCompleted)="afterCompleted($event)"
  (eventBubble)="eventBubble($event)" (afterSaved)="afterSaved($event)">
</lib-atividade-cadastro-view>